import {Route} from '@angular/router';
import {LandingPage} from '../components/landing-page/landing-page';
import {LoginComponent} from '../components/login-component/login-component';
import {
  FrequentlyAskedQuestionsComponent
} from '../components/frequently-asked-questions-component/frequently-asked-questions-component';
import {CookieContentComponent} from '../components/cookie-content-component/cookie-content-component';
import {PrivacyPolicyComponent} from '../components/privacy-policy-component/privacy-policy-component';
import {authGuard} from '../services/auth.guard';
import {FriendlyUrlGuard} from '../../projects/products-lib/src/lib/guards/friendly-url.guard';
import {rootRedirectGuard} from '../services/root-redirect.guard';
import {productSelectorGuard} from '../services/product-selector.guard';
import {SsoWaitingComponent} from '../components/sso-waiting-component/sso-waiting-component';

export const appRoutes: Route[] = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [rootRedirectGuard],
    component: LandingPage // fallback — guard always redirects
  },
  {
    path: 'product-selector',
    canActivate: [productSelectorGuard],
    loadComponent: () => import('../components/product-selector-component/product-selector-component').then(m => m.ProductSelectorComponent),
    data: {routeContext: 'product-selector'},
    title: 'Select a Product'
  },
  {path: 'login', component: LoginComponent, data: {routeContext: 'product-selector'}},
  // Inbound SSO from Kentico lands here (no guards) until the RevisionHub session exists
  {path: 'getting-ready', component: SsoWaitingComponent, title: 'Getting your RevisionHub ready'},
  {path: 'cookies', component: CookieContentComponent},
  {path: 'privacy', component: PrivacyPolicyComponent},
  {path: 'frequently-asked-questions', component: FrequentlyAskedQuestionsComponent},
  {
    path: '11-plus-online-comprehension-extract',
    loadComponent: () => import('../components/extract-page/extract-page.component').then(m => m.ExtractPageComponent),
    data: {hideChrome: true},
    title: '11 Plus Online Comprehension Extract'
  },
  {
    path: 'revision-hub', component: LandingPage,
    data: {routeContext: 'revision-hub'}
  },
  {
    path: 'products',
    canActivate: [authGuard],
    loadChildren: () => import('../../projects/products-lib/src/lib').then(m => m.ProductsLibModule),
    data: {routeContext: 'products'}
  },
  {
    path: 'samples',
    loadChildren: () => import('../../projects/products-lib/src/lib').then(m => m.ProductsLibModule),
    data: {routeContext: 'samples'}
  },
  {
    path: '11-plus-online-tests',
    loadComponent: () => import('../../projects/products-lib/src/lib/components/eleven-plus-online-component/eleven-plus-online-component').then(m => m.ElevenPlusOnlineComponent),
    data: {routeContext: 'eleven-plus'},
    title: '11+ Online Tests'
  },
  {
    path: '11-plus-online-account',
    canActivate: [authGuard],
    loadComponent: () => import('../components/eleven-plus-account-component/eleven-plus-account-component').then(m => m.ElevenPlusAccountComponent),
    data: {routeContext: 'eleven-plus'},
    title: 'Your 11+ Account'
  },
  // Friendly URL catch-all: maps human-readable slugs to canonical product routes.
  // e.g. /Bonjour -> /products/fas44, /Berlin -> /products/dar42
  // Add new mappings in product-data.Service.
  {
    path: ':friendlyUrl',
    canActivate: [FriendlyUrlGuard],
    component: LandingPage,
    data: {routeContext: 'eleven-plus'},
    title: '11+ Online Tests'
  },
];
